import Dropdown from 'components/formElements/Dropdown'
import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import Button from 'components/formElements/Button'
import { openSidebar } from 'redux/features/general/generalSlice'
import Icons from 'assets/icons'
import { useEffect } from 'react'
import { useRequest } from 'hooks/useRequest'
import images from 'assets/images/images'
import {Link, NavLink} from 'react-router-dom'
import {userInfo} from 'utils/Auth'
import {menu} from 'utils/Constants'
import {useDispatch} from 'react-redux'

const Navbar = () => {
	const [logout] = useRequest()
	//const location = useLocation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [sideMenu, setSideMenu] = useState([])
	useEffect(() => {
		if (userInfo) {
			setSideMenu(menu.filter(m => !m.disabled).map(m => m?.subMenu ? ({...m,subMenu:m.subMenu.filter(s => !s.disabled)}) : ({...m})))
		}
		return () => setSideMenu([])
	},[userInfo])
	// const getPageTitle = () => {
	// 	const menuItem = [
	// 		{ name: "Görevler", path: '/tasks' },
	// 		{ name: "Kullanıcılar", path: '/users' },
	// 		{ name: "Projeler", path: '/projects' },
	// 		{ name: "Fatura Raporları", path: '/billing-statement' },
	// 		{ name: "Fatura Kesilebilir Raporu", path: '/invoice-report' },
	// 		{ name: "Ödeme Raporları", path: '/billing-report' },
	// 		{ name: "Ayarlar", path: '/settings' },
	// 	].find((m) => m.path == location.pathname)
	// 	return menuItem ? menuItem.name : ''
	// }
	const [user, setUser] = useState()
	// const darkModeFunc = () => {
	// 	dispatch(darkMode())
	// }

	// const searchingList = [
	// 	{ taskName: '657-Intranette seyahat talepleri görüntüleme problemi' },
	// 	{ taskName: '658-Intranette seyahat talepleri görüntüleme problemi' },
	// 	{ taskName: '659-Intranette seyahat talepleri görüntüleme problemi' },
	// 	{ taskName: '660-Intranette seyahat talepleri görüntüleme problemi' },
	// 	{ taskName: '661-Intranette seyahat talepleri görüntüleme problemi' },
	// 	{ taskName: '662-Intranette seyahat talepleri görüntüleme problemi' },
	// ]
	// const searchRedirect = () => {
	// 	navigate('/tasks/1')
	// 	setKeyword('')
	// }
	const handleLogout = () => {
		logout('/Account/Logout', {
			method: 'POST'
		}).then(res => {
			if (res.status == 200) {
				localStorage.removeItem('auth')
				localStorage.removeItem('userInfo')
				navigate('/login')
			}
		})

	}
	useEffect(() => {
		setUser(JSON.parse(localStorage.getItem('auth')))
	}, [])
	return (
		<div className='navbar'>
			<div className='navbar-left'>
			<Icons.menu id='navbar' onClick={() => dispatch(openSidebar())} className='navbar-left-toggle' size={45} />
				<Link to='/projects' className='navbar-left-logo'>
					<img src={images.logo} alt='' />
				</Link>
			</div>
			<div className="navbar-menu">
			{sideMenu?.map((mn, i) => (
				mn?.subMenu?.length > 0 
				? <div className={`navbar-menu-item`} key={i}>
					<span className='navbar-menu-item-text'>
						{mn.name}
					</span>
					{
						mn?.subMenu?.length > 0 && <div className='navbar-menu-item-submenu'>
							{
								mn.subMenu.map((sub,subindex) => (
									<NavLink className='navbar-menu-item' to={sub.path} key={subindex}>
										<span className='navbar-menu-item-text'>
											{sub.name}
										</span>
									</NavLink>
								))
							}
						</div>
					}
				</div>
				: <NavLink className={`navbar-menu-item`} to={mn.path && mn.path} key={i}>
					<span className='navbar-menu-item-text'>
						{mn.name}
					</span>
				</NavLink>
			))}
			</div>
			{/* <div className='navbar-searching-container'>
				<div style={keyword ? { borderRadius: '5px 5px 0px 0px' } : {}} className='navbar-center'>
					<input
						value={keyword}
						onChange={(e) => setKeyword(e.target.value)}
						className='navbar-center-input'
						type='text'
						placeholder={width < 400 ? 'Arama Yapın...' : 'Herhangi bir kelime girerek arayabilirsiniz'}
					/>
					<icons.search size={20} />
				</div>
				{keyword.length >= 3 && (
					<div className='navbar-searching-container-results'>
						{searchingList
							.filter((src) => src.taskName.toLowerCase().includes(keyword) && keyword.length >= 3)
							.map((search, i) => (
								<AnimatedSpan key={i}>
									<div onClick={searchRedirect} className='navbar-searching-container-results-val text-md'>
										{search.taskName.substring(0, 45) + '...'}
									</div>
								</AnimatedSpan>
							))}
					</div>
				)}
			</div> */}
			<div className='navbar-right'>
				
				<Dropdown
					trigger={
						<div className='navbar-right-text cursor-pointer'>
							<div className='text-bold'>{user?.firstName} {user?.lastName}</div>
							{/* <div className='text-sm text-muted'>Team Manager</div> */}
						</div>
					}
					classNames={{ container: 'dropdown-menu notification-container', item: '-' }}
					menu={[
						<Button key={1} handleClick={handleLogout} icon={<Icons.logout size={15} />} className='btn w-100' title='Çıkış Yap' />
					]}
				/>

				{/* <div style={{ cursor: 'pointer' }} onClick={darkModeFunc}>
					{!dark ? <icons.dark size={25} /> : <icons.light size={25} />}
				</div> */}
				{/* <div className='navbar-right-translate'>
					<Dropdown
						trigger={
							<div className='navbar-right-translate-btn'>
								<span className='text-bold'>EN</span>
								<icons.arrowDown className='d-flex' size={14} />
							</div>
						}
						classNames={{ container: 'navbar-right-translate-container', item: 'navbar-right-translate-container-item' }}
						menu={[<React.Fragment key={1}>EN</React.Fragment>, <React.Fragment key={2}>TR</React.Fragment>]}
					/>
				</div> */}
			</div>
		</div>
	)
}

export default Navbar
